import { type Locale, baseLocale, getLocale } from '@/paraglide/runtime';

/** The BCP 47 tag each locale formats numbers and dates in, and declares in `lang`. */
export const languageTags = {
  en: 'en-GB',
  zh: 'zh-Hans',
} as const satisfies Record<Locale, string>;

/** The current page's language tag, read from its URL. */
export function languageTag() {
  return languageTags[getLocale()];
}

/** The language tag for output that is only ever written in English, like the news feed. */
export const baseLanguageTag = languageTags[baseLocale];

/** How each locale is named to search engines in `hreflang`; plain `en` covers every English market. */
export const hreflangTags = {
  en: 'en',
  zh: 'zh-Hans',
} as const satisfies Record<Locale, string>;

/** `og:locale` wants a language and territory. */
export const ogLocales = {
  en: 'en_GB',
  zh: 'zh_CN',
} as const satisfies Record<Locale, string>;

/** Each language named in itself, the same on every page, so a reader can find their own. */
export const nativeNames = {
  en: 'English',
  zh: '简体中文',
} as const satisfies Record<Locale, string>;

/** The short form the header's switcher shows. */
export const shortNames = {
  en: 'EN',
  zh: '中文',
} as const satisfies Record<Locale, string>;
